angular.module('iqxCore')
  .controller('CandidateDetailsCtrl', function ($scope, $location, $routeParams, FormSvc, QuestionnaireSvc, $sce, $http, ApplicationSvc, ApiSvc) {
    $scope.userCanEdit = true
    $scope.caneditNI = $scope.userHasRight('CANEDITNI')
    $scope.caneditName = $scope.userHasRight('CANEDITNAME')
    $scope.lang = $scope.params.lang
    $scope.autocompleteResults = []
    $scope.autocompleteEnabled = $scope.params.ADDRESSLOOKUP
    $scope.addressLookupPlaceholder = $scope.autocompleteEnabled ? 'Start typing your address or postcode' : ''
    $scope.titlesForPayroll = [
      { Value: "Mr", Descrip: "Mr" },
      { Value: "Mrs", Descrip: "Mrs" },
      { Value: "Ms", Descrip: "Ms" },
      { Value: "Miss", Descrip: "Miss" },
      { Value: "Dr", Descrip: "Dr" },
      { Value: "Prof", Descrip: "Prof" },
      { Value: "Rev", Descrip: "Rev" }
    ]

    if ($scope.userHasRight('CANDHIDEDETAILSPAGE')) {
      $location.url('/noPermission')
    }

    if ($scope.userHasRight('CANDDETAILSREADONLY')) {
      $scope.userCanEdit = false
      var header = document.querySelectorAll('form .panel-heading .btn-primary')
      angular.forEach(header, function (elm, key) {
        header[key].setAttribute('class', 'hide')
      })

      var footer = document.querySelectorAll('form .panel-footer .btn-primary')
      angular.forEach(footer, function (elm, key) {
        footer[key].setAttribute('class', 'hide')
      })

      var formElements = document.querySelectorAll('form input')
      angular.forEach(formElements, function (elm, key) {
        formElements[key].setAttribute('ng-disabled', 'true')
      })
    }

    FormSvc.setOptions($scope, {
      fetchAPI: 'callresult/netcandidateprofile',
      saveAPI: 'call/netcandidateprofileset',
      savePrefix: 'p',
      saveWithPersonID: false, // is already in the record!
      fetchWithPersonID: true,
      dateFields: ['DOB'],
      booleanFields: ['OptInToMarketing'],
      primaryKey: 'PersonID',
      questionnaire: {
        tagTarget: 'tags',
        tagLocation: 'P',
        displayGroup: '?CANDIDATE',
        id: ApplicationSvc.currentUser.personID,
        postVar: 'qanswers'
      }
    })

    $scope.dateOptions.datepickerMode = 'year'
    $scope.dateOptions.initDate = moment().subtract('30', 'y').toDate()

    function includes(c, v) {
      var returnValue = false;
      var pos = c.indexOf(v);
      if (pos >= 0) {
        returnValue = true;
      }
      return returnValue;
    }

    $scope.changepassword = function () {
      $location.path('/changepassword')  // Add departmental registration details
    }

    $scope.doUpdate = function () {  // Over-ride the default update() called by the Save & Submit button
      if ($scope.theRecord.NINumber) {
        $scope.theRecord.NINumber = $scope.theRecord.NINumber.replace(/ /g, '')
      }
      // 10 char check on the UTR number.
      if ($scope.theRecord.UTR && $scope.theRecord.UTR.length !== 10 && $scope.userHasRight('CANDUTR')) {
        FormSvc.alert('', 'The UTR must be exactly 10 digits. No other characters are allowed.', 'error')
        return false
      }
      FormSvc.setSubmitted($scope, true)
      return FormSvc.update($scope, false, false)  // Do not do the fetch if submitted
        .then(function (err) {
          if (!err) {
            FormSvc.alert("Saved", "Your details have been updated.", "success")
          }
        })
        .catch(function (err) {
          // Catch if a user is trying to change their email address to one that already exists!!
          if (err.iqxError.text === "[FireDAC][Phys][ODBC][SAP][ODBC Driver][SQL Anywhere]Index 'IQXNetUserEmailAddress' for table 'IQXNetUser' would not be unique") {
            FormSvc.alert('An account may already exist with that email address.', 'Please contact us to resolve this.', 'error')
          }
        })
    }
    $scope.update = $scope.doUpdate
    $scope.classes = { label: 'col-sm-10', data: 'col-sm-2' }

    $scope.addressAutocomplete = async function (input) {
      if ($scope.autocompleteEnabled === false) { return }
      $scope.autocompleteResults[input] = null
      $scope.autocompleteResults[input] = await ApiSvc.exec($scope, 'addressLookup/autocomplete', { autocomplete: $scope.theRecord[input] })
        .catch((e) => {
          $scope.autocompleteResults = []
          $scope.autocompleteEnabled = false
        })
    }

    $scope.selectAddress = async function (address) {
      if ($scope.autocompleteEnabled === false) { return }
      $scope.autocompleteResults = []
      var fullAddress = await ApiSvc.exec($scope, 'addressLookup/getFull', { udprn: address.udprn })
        .catch((e) => {
          $scope.autocompleteResults = []
          $scope.autocompleteEnabled = false
        })
      updateAddressFields(fullAddress.IQXResult.Row)
    }

    function updateAddressFields(address) {
      $scope.theRecord.Addr1 = address.line_1
      $scope.theRecord.Addr2 = address.line_2
      $scope.theRecord.Addr3 = address.line_3
      $scope.theRecord.Town = address.post_town
      if ($scope.params.INCCOUNTY === true) {
        $scope.theRecord.County = address.county
      }
      if ($scope.params.INCCOUNTRY === true || $scope.params.OVERRIDECOUNTRY) {
        $scope.theRecord.Country = address.country
      }
      $scope.theRecord.Postcode = address.postcode
    }

    $scope.fetch()
  })